import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/proposta', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./domain/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./domain/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/proposta', pathMatch: 'full' },
      {
        path: 'proposta',
        loadChildren: () =>
          import('./domain/proposta/proposta.module').then(
            m => m.PropostaModule,
          ),
      },
      {
        path: 'lead',
        loadChildren: () =>
          import('./domain/lead/lead.module').then(m => m.LeadModule),
      },
      {
        path: 'empresa',
        loadChildren: () =>
          import('./domain/empresa/empresa.module').then(m => m.EmpresaModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
